import { render, staticRenderFns } from "./AccountingBookBadge.vue?vue&type=template&id=05a74c51&scoped=true&"
import script from "./AccountingBookBadge.vue?vue&type=script&lang=js&"
export * from "./AccountingBookBadge.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBookBadge.vue?vue&type=style&index=0&id=05a74c51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a74c51",
  null
  
)

export default component.exports